// extracted by mini-css-extract-plugin
export default {"label":"styles-module__label__src-labstep-web-components-Protocol-Version-_qyE1f"};